import React, { useEffect, useState } from 'react'
import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    Form,
    Input,
    InputNumber, 
    Space,
    Checkbox,
    Divider
} from 'antd'
import toast from 'react-hot-toast';
import Navbar from '../../Components/Navbar/Navbar'

import { 
  ProductOutlined,
  // DeleteOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { extractAmount, formatAmount, formatDate } from '../../Utils/Common';
const { Item } = Form;

const EditTenantRate = () => {
  const navigate = useNavigate()
  const { id } = useParams();
  // const defaultAdvanceRental = 1;
  const [tenantData, setTenantData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isDeposit, setIsDeposit] = useState(false)
  const [isAdvance, setIsAdvance] = useState(false)
  const [isBond, setIsBond] = useState(true)
  const [isElectric, setIsElectric] = useState(false)
  const [isWater, setIsWater] = useState(false)
  const [isGas, setIsGas] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [rentalValue, setRentalValue] = useState('')
  const [parkingDataTable, setParkingDataTable] = useState([])
  const [parkingPayables, setParkingPayables] = useState({
    with_parking_security_deposit: false,
    with_parking_advance_rental: false,
  });

  const [escalationSpace, setEscalationSpace] = useState(['0.00'])
  const [escalationCusa, setEscalationCusa] = useState(['0.00'])
  const [escalationAlfresco, setEscalationAlfresco] = useState(['0.00'])
  const [meterForm] = Form.useForm();
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />; // Custom spinner component
  const { callPost, loading, data } = usePostRequest(()=>{
    fetchTenantData();
    fetchRateData();
  });

  const handleSaveValidation = () => {
    var isValid = false;

    if(parkingPayables.with_parking_advance_rental){
        isValid = parkingDataTable.some(row => 
            !row.parking_advance_rental_months
        );
    }

    return isValid;
};

  React.useEffect(() => {
    if (data) {
        navigate('/tenant/print-soa/move-in/' + data.tenant_id);
    }
  }, [data, navigate]);

  const generateSpaceRental = (tenant) => {
    const rates = [];
    const term = tenant?.lease_type === "year" ? tenant?.lease_term : 1;
    for (let i = 0; i < term; i++) {
      let basicRent = parseFloat(tenant?.space_rate_final) + parseFloat(tenant?.space_rate_final * ((escalationSpace[i] || 0)/100));
      let vat = basicRent * 0.12;
      let ewt = basicRent * 0.05;
  
      basicRent = isNaN(basicRent) ? 0 : basicRent.toFixed(2);
      vat = isNaN(vat) ? 0.00 : vat.toFixed(2);
      ewt = isNaN(ewt) ? 0.00 : ewt.toFixed(2);
  
      let totalRent = parseFloat(basicRent) + parseFloat(vat) - parseFloat(ewt);

      rates.push({
        key: `${i}`,
        year: `${i + 1}`,
        rental_type: 'space',
        escalation: escalationSpace[i] || 0,
        basic_rent: `${basicRent}`,
        vat: `${vat}`,
        ewt: `${ewt}`,
        total_rent: `${totalRent.toFixed(2)}`,
      });
    }
  
    return rates;
  };

  const generateCusaRental = (tenant) => {
    const rates = [];
    const term = tenant?.lease_type === "year" ? tenant?.lease_term : 1;

    for (let i = 0; i < term; i++) {
      let basicRent = parseFloat(tenant.cusa_rate_final) + (parseFloat(tenant.cusa_rate_final ) * parseFloat(((escalationCusa[i] || 0)/100)));
      let vat = basicRent * 0.12;
      let ewt = basicRent * 0.05;
  
      basicRent = isNaN(basicRent) ? 0 : basicRent.toFixed(2);
      vat = isNaN(vat) ? 0.00 : vat.toFixed(2);
      ewt = isNaN(ewt) ? 0.00 : ewt.toFixed(2);
  
      let totalRent = parseFloat(basicRent) + parseFloat(vat) - parseFloat(ewt);

      rates.push({
        key: `${i}`,
        year: `${i + 1}`,
        rental_type: 'cusa',
        escalation: escalationCusa[i] || 0,
        basic_rent: `${basicRent}`,
        vat: `${vat}`,
        ewt: `${ewt}`,
        total_rent: `${totalRent.toFixed(2)}`,
      });
    }
  
    return rates;
  };

  const generateAlfrescoRental = (tenant) => {
    const rates = [];
    const term = tenant?.lease_type === "year" ? tenant?.lease_term : 1;
    
    for (let i = 0; i < term; i++) {
      let basicRent = parseFloat(tenant?.alfresco_rate_final) + parseFloat(tenant?.alfresco_rate_final * ((escalationAlfresco[i] || 0)/100));
      let vat = basicRent * 0.12;
      let ewt = basicRent * 0.05;
  
      basicRent = isNaN(basicRent) ? 0 : basicRent.toFixed(2);
      vat = isNaN(vat) ? 0.00 : vat.toFixed(2);
      ewt = isNaN(ewt) ? 0.00 : ewt.toFixed(2);
  
      let totalRent = parseFloat(basicRent) + parseFloat(vat) - parseFloat(ewt);

      rates.push({
        key: `${i}`,
        year: `${i + 1}`,
        rental_type: 'alfresco',
        escalation: escalationAlfresco[i] || 0,
        basic_rent: `${basicRent}`,
        vat: `${vat}`,
        ewt: `${ewt}`,
        total_rent: `${totalRent.toFixed(2)}`,
      });
    }
  
    return rates;
  };
  
  // const isAnyEscalationEmpty = (space_rental) => {
  //   return space_rental.some(item => item.escalation === '');
  // };
  
  const options = [
    { label: 'Condo Dues', value: 'Condo Dues' },
    { label: 'Sewer Fee', value: 'Sewer Fee' },
    { label: 'Cable and Internet', value: 'Cable and Internet' },
  ];

  const [checkedValues, setCheckedValues] = useState([]);

  const onCheckedValues = (value) => {
    const newCheckedValues = checkedValues?.includes(value)
      ? checkedValues?.filter((v) => v !== value)
      : [...checkedValues, value];

    setCheckedValues(newCheckedValues);
  };

  const onParkingCheckedValues = (value, name) => {
    setParkingPayables((prev) => ({
      ...prev,
      [name]: value
    }))
  };

  const space_rental = generateSpaceRental(tenantData)
  const cusa_rental = generateCusaRental(tenantData)
  const alfresco_rental = generateAlfrescoRental(tenantData)
  const handleAddRates = () => {
    meterForm.validateFields().then(values => {
      const units = [];

      if (tenantData?.space_rental_rate !== "0.00") {
        units.push(...space_rental);
      }

      if (tenantData?.cusa_rental_rate !== "0.00") {
        units.push(...cusa_rental);
      }

      if (tenantData?.alfresco_rental_rate !== "0.00") {
        units.push(...alfresco_rental);
      }

      const data = {
        tenant_id: id,
        year: units.map((item)=>item.year),
        rental_type: units.map((item)=>item.rental_type),
        escalation: units.map((item)=>item.escalation || "0.00"),
        basic_rent: units.map((item)=>item.basic_rent),
        vat: units.map((item)=>item.vat),
        ewt: units.map((item)=>item.ewt),
        total_rent: units.map((item)=>item.total_rent),

        with_parking_advance_rental: parkingPayables.with_parking_advance_rental, 
        with_parking_security_deposit: parkingPayables.with_parking_security_deposit, 
        parking_detail_ids: parkingDataTable.map((item)=>item.id),

        ...(parkingPayables.with_parking_advance_rental &&
          {
            parking_advance_rental_amounts: parkingDataTable.map((item)=>item.parking_advance_rental_amount),
            parking_advance_rental_months: parkingDataTable.map((item)=>item.parking_advance_rental_months),
          }
        ),
        ...(parkingPayables.with_parking_security_deposit &&
          {
            parking_security_deposit_amounts: parkingDataTable.map((item)=>item.parking_security_deposit_amount),
          }
        ),      
        ...(!isDeposit && 
          { 
            security_deposit_amount: values.security_deposit_amount, 
            with_security_deposit: !isDeposit
          }),
        ...(!isAdvance && 
          { 
            advance_rental_amount: extractAmount(values.advance_rental_amount), 
            advance_rental_months: values.advance_rental_months, 
            with_advance_rental: !isAdvance 
          }),
        ...(!isBond && 
          { 
            construction_bond_amount: values.construction_bond_amount, 
            with_construction_bond: !isBond 
          }),

        ...(values.elec_consumption && { elec_consumption: values.elec_consumption}),
        ...(values.water_consumption && { water_consumption: values.water_consumption}),
        ...(values.gas_consumption && { gas_consumption: values.gas_consumption }),
        
        payables: checkedValues.map((item)=>item),
      }
      
      var finalValues = Object.entries(data).map(([key, value]) => ({
          key,
          value,
      }));

      callPost(
        "tenants/rental_rate", 
        finalValues,
        true,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };
  
  const handleEditSpace = (key, e, type) => {
    if(type === "space"){
      setEscalationSpace(prevState => ({
        ...prevState,
        [key]: e,
      }));
    }
    if(type === "cusa"){
      setEscalationCusa(prevState => ({
        ...prevState,
        [key]: e,
      }));
    }
    if(type === "alfresco"){
      setEscalationAlfresco(prevState => ({
        ...prevState,
        [key]: e
      }));
    }
  };
  
  const  defaultColumnsSpace = [
    {
      title: 'Year',
      dataIndex: 'year',
    },
    {
      title: 'Escalation (%)',
      dataIndex: 'escalation',
      width: '30%',
      render: (_, record, index) => {
        if (index === 0) {
          return <span className='center'>0.00</span>;
        }
        return(
          <InputNumber
            value={record.escalation}
            onChange={(e) => handleEditSpace(record.key, e, "space")}
            style={{width:'100%'}}
            min={0}
            disabled={isDisabled}
          />
        )
      },
    },
    {
      title: 'Basic Rent',
      dataIndex: 'basic_rent',
      render: (basic_rent) => formatAmount(basic_rent),
    },
    {
      title: 'Plus 12% VAT',
      dataIndex: 'vat',
      render: (vat) => formatAmount(vat),
    },
    {
      title: 'Less 5% EWT',
      dataIndex: 'ewt',
      render: (ewt) => formatAmount(ewt),
    },
    {
      title: 'Total Rent',
      dataIndex: 'total_rent',
      render: (total_rent) => formatAmount(total_rent),
    },
  ];

  const defaultColumnsCusa = [
    {
      title: 'Year',
      dataIndex: 'year',
    },
    {
      title: 'Escalation (%)',
      dataIndex: 'escalation',
      width: '30%',
      render: (_, record, index) => {
        if (index === 0) {
          return <span className='center'>0.00</span>;
        }
        return(
          <InputNumber
            value={record.escalation}
            onChange={(e) => handleEditSpace(record.key, e, "cusa")}
            style={{width:'100%'}}
            min={0}
            disabled={isDisabled}
          />
        )
      },
    },
    // {
    //   title: 'Escalation Value',
    //   dataIndex: 'escalation',
    // },
    {
      title: 'Basic Rent',
      dataIndex: 'basic_rent',
      render: (basic_rent) => formatAmount(basic_rent),
    },
    {
      title: 'Plus 12% VAT',
      dataIndex: 'vat',
      render: (vat) => formatAmount(vat),
    },
    {
      title: 'Less 5% EWT',
      dataIndex: 'ewt',
      render: (ewt) => formatAmount(ewt),
    },
    {
      title: 'Total Rent',
      dataIndex: 'total_rent',
      render: (total_rent) => formatAmount(total_rent),
    },
  ];

  const defaultColumnsAlfresco = [
    {
      title: 'Year',
      dataIndex: 'year',
    },
    {
      title: 'Escalation (%)',
      dataIndex: 'escalation',
      width: '30%',
      render: (_, record, index) => {
        if (index === 0) {
          return <span className='center'>0.00</span>;
        }
        return(
          <InputNumber
            value={record.escalation}
            onChange={(e) => handleEditSpace(record.key, e, "alfresco")}
            style={{width:'100%'}}
            min={0}
            disabled={isDisabled}
          />
        )
      },
    },
    // {
    //   title: 'Escalation Value',
    //   dataIndex: 'escalation',
    // },
    {
      title: 'Basic Rent',
      dataIndex: 'basic_rent',
      render: (basic_rent) => formatAmount(basic_rent),
    },
    {
      title: 'Plus 12% VAT',
      dataIndex: 'vat',
      render: (vat) => formatAmount(vat),
    },
    {
      title: 'Less 5% EWT',
      dataIndex: 'ewt',
      render: (ewt) => formatAmount(ewt),
    },
    {
      title: 'Total Rent',
      dataIndex: 'total_rent',
      render: (total_rent) => formatAmount(total_rent),
    },
  ];

  const columnsSpace = defaultColumnsSpace.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  const columnsCusa = defaultColumnsCusa.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  const columnsAlfresco = defaultColumnsAlfresco.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  async function fetchTenantData  () {
    setIsLoading(true)
    const response = await UseGetRequest("tenants/get", {tenant_id: id});
    if (response?.data) {
      setTenantData(response?.data?.data[0]);
      if(response?.data?.data[0]?.payables){
        const initialCheckedValues = response?.data?.data[0]?.payables?.map(payable => payable.description);
        setCheckedValues(initialCheckedValues);
      }

      if(response?.data?.data[0]?.tenant_parkings){
        setParkingDataTable(response?.data?.data[0]?.tenant_parkings);
      }

      meterForm.setFieldsValue({
        elec_consumption: response?.data?.data[0].elec_consumption,
        water_consumption: response?.data?.data[0].water_consumption,
        gas_consumption: response?.data?.data[0].gas_consumption, 
        security_deposit_amount: response?.data?.data[0]?.security_deposit?.amount,
        construction_bond_amount: response?.data?.data[0]?.construction_bond?.amount, 
      });

      if(response?.data?.data[0]?.advance_rental){
        meterForm.setFieldsValue({
          advance_rental_amount: response?.data?.data[0]?.advance_rental?.amount,
          advance_rental_months: response?.data?.data[0]?.advance_rental?.months,
        });
      } else {
        meterForm.setFieldsValue({
          advance_rental_amount: formatAmount(parseFloat(rentalValue) * parseFloat(0)),
          advance_rental_months: 0,
        });
      }

      setIsDisabled(
        (
          response?.data?.data[0]?.security_deposit ||
          response?.data?.data[0]?.advance_rental ||
          response?.data?.data[0]?.construction_bond
        ) ? true : false 
      )
    } else {
      setTenantData([])
    }
    setIsLoading(false)
  }
  const splitDataByRentalType = (data) => {
    const splitData = {};
    data.forEach(item => {
        const rentalType = item.rental_type;

        if (!splitData.hasOwnProperty(rentalType)) {
            splitData[rentalType] = [];
        }

        splitData[rentalType].push(item);
    });

    return splitData;
  };

  const multipleMonth = (data) => {
    if(data){
      meterForm.setFieldsValue({
        advance_rental_amount: formatAmount(parseFloat(rentalValue) * parseFloat(data)),
      });
    }
  };
  async function fetchRateData() {
    setIsLoading(true)
    const response = await UseGetRequest("tenants/rental_rate_history", {tenant_id: id});
    if (response?.data) {
      // setTenantRateData(response?.data?.data);
      const splitData = splitDataByRentalType(response?.data?.data);

      const space = splitData["space"] || [];
      const cusa = splitData["cusa"] || [];
      const alfresco = splitData["alfresco"] || [];

      const escalationSpace = space.map(data => data.escalation);
      setEscalationSpace(escalationSpace);
      setRentalValue(space[0]?.basic_rent)

      const escalationCusa = cusa.map(data => data.escalation);
      setEscalationCusa(escalationCusa);

      const escalationAlfresco = alfresco.map(data => data.escalation);
      setEscalationAlfresco(escalationAlfresco);

    } 
    else {
      setEscalationCusa([])
      setEscalationSpace([])
      setEscalationAlfresco([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchTenantData();
    fetchRateData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleInputChange = (e, fieldName, recordKey, dataRow) => {
    const updatedDataSource = parkingDataTable.map((item, index) => {
      if (index === recordKey) {
        if(fieldName === 'parking_advance_rental_months'){
          return { 
            ...item, 
            [fieldName]: e, 
            parking_advance_rental_amount: e *  parseFloat(dataRow.parking_rental_rate)
          };
        } else {
          return { ...item, [fieldName]: e };
        }
      }
      return item;
    });
    setParkingDataTable(updatedDataSource);
  };

  // const handleAddRow = () => {
  //   const newRow = {
  //     items: "",
  //     amounts: "",
  //   };
  //   setParkingDataTable(prev => [...prev, newRow]);
  // };

  // const handleDeleteRow = (rowId) => {
  //   const newData = [...parkingDataTable];
  //   newData.splice(rowId, 1); 
  //   setParkingDataTable(() => newData)
  // };

  const columns = [
    {
      title: 'Parking Unit',
      dataIndex: 'parking_unit_name',
      key: 'parking_unit_name'
    },
    {
      title: 'Parking Rental Rate',
      dataIndex: 'parking_rental_rate',
      key: 'parking_rental_rate',
      render: (e) => formatAmount(e)
    },
    {
      title: 
        <div>
          <span>
            {
              !isDisabled && (
                <Checkbox
                  onChange={(e) => onParkingCheckedValues(e.target.checked,'with_parking_security_deposit')}
                />
              )
            }
          </span> Security Deposit
        </div>,
      dataIndex: 'parking_security_deposit_amount',
      render: (_, record, index) => (
        !isDisabled ? (
          <InputNumber
            style={{width:'100%'}}
            value={!parkingPayables.with_parking_security_deposit ? '0.00' : record.parking_security_deposit_amount}
            disabled={!parkingPayables.with_parking_security_deposit}
            onChange={(e) => handleInputChange(e, 'parking_security_deposit_amount', index)}
          />
          
        ) : (
          <InputNumber
            style={{width:'100%'}}
            value={record.security_deposit ? formatAmount(record.security_deposit) : 0}
            disabled={true}
          />
        )
      ),
    },
    {
      title: 
        <div>
          <span>
            {
              !isDisabled && (
                <Checkbox
                  onChange={(e) => onParkingCheckedValues(e.target.checked,'with_parking_advance_rental')}
                />
              )
            }
          </span> Advance Rental
        </div>,
      dataIndex: 'parking_advance_rental_amount',
      render: (_, record, index) => (
        !isDisabled ? (
          <>
            <InputNumber
              style={{width:'75%'}}
              className='me-2'
              value={!parkingPayables.with_parking_advance_rental ? '0.00' : formatAmount(record.parking_advance_rental_amount)}
              disabled={true}
              onChange={(e) => handleInputChange(e, 'parking_advance_rental_amount', index)}
            />
            <InputNumber 
              style={{width:'20%'}} 
              precision={0}
              step={1}
              onChange={(e) => handleInputChange(e, 'parking_advance_rental_months', index, record)}
              disabled={!parkingPayables.with_parking_advance_rental}
              value={!parkingPayables.with_parking_advance_rental ? '0' : record.parking_advance_rental_months}
              min={!parkingPayables.with_parking_advance_rental ? 1 : undefined} 
              max={tenantData.lease_type === 'year' ? parseInt(tenantData.lease_term) * 12 : parseInt(tenantData.lease_term)}
            />
          </>
        ) : (
          <>
            <InputNumber
              style={{width:'75%'}}
              className='me-2'
              value={record.advance_rental ? formatAmount(record.advance_rental) : 0}
              disabled={true}
            />
            <InputNumber 
              style={{width:'20%'}} 
              precision={0}
              step={1}
              disabled={true}
              value={record.advance_rental_month}
              max={tenantData.lease_type === 'year' ? parseInt(tenantData.lease_term) * 12 : parseInt(tenantData.lease_term)}
            />
          </>
        )
      ),
    },
    // {
    //   title: 'Action',
    //   dataIndex: 'action',
    //   align: 'center',
    //   render: (_,record, index) => (
    //    <div className='center'>
    //       <Button
    //         icon={<DeleteOutlined />}
    //         onClick={() => handleDeleteRow(index)}
    //         type="link"
    //         size='large'
    //         danger
    //       />
    //    </div>
    //   ),
    // },
  ];

  // useEffect(() => {
  //   if(!isAdvance){
  //     meterForm.setFieldsValue({
  //       advance_rental_amount: formatAmount(parseFloat(rentalValue) * parseFloat(defaultAdvanceRental)),
  //     });
  //   } else {
  //     meterForm.setFieldsValue({
  //       advance_rental_amount: formatAmount(parseFloat(rentalValue) * parseFloat(0)),
  //       advance_rental_months: 0,
  //     });
  //   }
    
  // }, [rentalValue,defaultAdvanceRental,meterForm, isAdvance]);
  return (
    <Layout className='page'>
        <Navbar/>
        <Layout className='content-container p-4 overflow-y'>
            <Row className='responsive-inline responsive-tab-inline'>
              <Col span={18} className='header-container'>
                  TENANT RATES & PAYABLES ({tenantData.trade_name})
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col span={15} align="left">
                  <Space>
                      <div>
                        Property :
                      </div>
                      <div className='bold-text'>
                          {tenantData?.property_name}
                      </div>
                  </Space>
              </Col>
              <Col span={9} align="left">
                <Space>
                    <div>
                      Contract Date :
                    </div>
                    <div className='bold-text'>
                        {formatDate(tenantData?.contract_sign_date)} - {formatDate(tenantData?.contract_end_date)}
                    </div>
                </Space>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col span={15} align="left">
                <Space>
                    <div>
                      Rental Unit :
                    </div>
                    <div className='bold-text'>
                        {tenantData?.rental_unit_name}
                    </div>
                </Space>
            </Col>
            <Col span={9} align="left">
                <Space>
                    <div>
                      Lease Term :
                    </div>
                    <div className='bold-text'>
                        {tenantData?.lease_term} ( {tenantData?.lease_type} )
                    </div>
                </Space>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col span={15} align="left">
              <Space>
                  <div>
                    Location :
                  </div>
                  <div className='bold-text'>
                      {tenantData?.business_address}
                  </div>
              </Space>
              </Col>
            <Col span={9} align="left">
               
            </Col>
          </Row>
          <Divider className='divider-text'>Rates</Divider>
          <Row className='mb-4'>
            <Col span={24}>
              <Row>
                  <Col span={24} className='p-2'>
                      Space Rental Table
                  </Col>
              </Row>
              <Row className='responsive-overflow-y'>
                <Col span={24} className='p-2'>
                  <Table
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={space_rental}
                    columns={columnsSpace}
                    pagination={false}
                    loading={{
                      indicator: customSpinner, // Use custom spinner
                      spinning: isLoading, // Set spinning based on loading state
                    }}
                  />
                </Col>
              </Row>
              {
                (tenantData?.cusa_rental_rate !== "0.00") && (
                  <>
                    <Row>
                      <Col span={24} className='p-2'>
                          Cusa Rental Table
                      </Col>
                    </Row>
                    <Row className='responsive-overflow-y'>
                      <Col span={24} className='p-2'>
                        <Table
                          // components={components}
                          rowClassName={() => 'editable-row'}
                          bordered
                          dataSource={cusa_rental}
                          columns={columnsCusa}
                          pagination={false}
                          loading={{
                            indicator: customSpinner, // Use custom spinner
                            spinning: isLoading, // Set spinning based on loading state
                          }}
                        />
                      </Col>
                    </Row>       
                  </>
                )
              }
              {
                (tenantData?.alfresco_rental_rate !== "0.00") && (
                  <>
                    <Row>
                          <Col span={24} className='p-2'>
                              Alfresco Rental Table
                          </Col>
                      </Row>
                      <Row className='responsive-overflow-y'>
                          <Col span={24} className='p-2'>
                            <Table
                              // components={components}
                              rowClassName={() => 'editable-row'}
                              bordered
                              dataSource={alfresco_rental}
                              columns={columnsAlfresco}
                              pagination={false}
                              loading={{
                                indicator: customSpinner, // Use custom spinner
                                spinning: isLoading, // Set spinning based on loading state
                              }}
                            />
                          </Col>
                      </Row>
                  </>
                )
              }
            </Col>
          </Row>
          <Divider className='divider-text'>Payables</Divider>
          <Form 
            form={meterForm} 
            layout="vertical"
            // initialValues={{
            //   advance_rental_months: defaultAdvanceRental, // Setting the default value
            // }}        
          >
            <Row>
              <Col span={10}>
                <Row className='m-2'>
                  <Col span={7}>
                    <Space>
                      {!isDisabled &&<Checkbox value="security_deposit"  checked={!isDeposit}  onClick={() => setIsDeposit(!isDeposit)}/>}
                      <Item
                        label="Security Deposit "
                        name="security_deposit_amount"
                        rules={!(isDeposit || isDisabled)&&[{ required: true, message: 'Please enter your Security Bond!' }]}
                      >
                        <InputNumber 
                          style={{width:'20vw'}} 
                          disabled={isDeposit || isDisabled}
                          min={!isDeposit ? 1 : undefined} 
                        />
                      </Item>
                    </Space>
                  </Col>
                </Row>
                <Row className='m-2'>
                  <Col span={7}>
                    <Space>
                      {!isDisabled &&<Checkbox value="advance_rental" checked={!isAdvance}  onClick={() => setIsAdvance(!isAdvance)}/>}
                      <Item
                        label="Advance Rental "
                        name="advance_rental_amount"
                        // rules={!(isAdvance || isDisabled)&&[{ required: true, message: 'Please enter your Advance Rental!' }]}
                      >
                        <InputNumber 
                          style={{width:'20vw'}} 
                          disabled={true}
                          min={!isAdvance ? 1 : undefined} 
                        />
                      </Item>
                      <Item
                        label="Months"
                        name="advance_rental_months"
                        rules={!(isAdvance || isDisabled) && [{ required: true, message: 'Please enter your months!' }]}
                      >
                        <InputNumber 
                          style={{width:'5vw'}} 
                          disabled={isAdvance || isDisabled}
                          onChange={(e) => multipleMonth(e)}
                          precision={0}
                          step={1}
                          max={tenantData.lease_type === 'year' ? parseInt(tenantData.lease_term) * 12 : parseInt(tenantData.lease_term)}
                          min={!isAdvance ? 1 : undefined} 
                        />
                      </Item>
                    </Space>
                  </Col>
                </Row>
                <Row className='m-2'>
                  <Col span={10}>
                    <Space>
                      {/* <Button type="primary" size="small" onClick={() => setIsBond(!isBond)}>
                        {!isBond ? 'Disable' : 'Enable'}
                      </Button> */}
                      {!isDisabled &&<Checkbox value="construction_bond"  checked={!isBond}   onClick={() => setIsBond(!isBond)}/>}
                      <Item
                        label="Construction Bond "
                        name="construction_bond_amount"
                        rules={!(isBond || isDisabled) && [{ required: true, message: 'Please enter your Construction Bond!' }]}

                      >
                        <InputNumber 
                          style={{width:'20vw'}} 
                          disabled={isBond || isDisabled}
                          min={!isBond ? 1 : undefined} 
                        />
                      </Item>
                    </Space>
                  </Col>
                </Row>
              </Col>
              <Col span={9}>
                <Row className='m-2'>
                  <Col>
                    <Space>
                      {!isDisabled &&<Checkbox value="electric_water"  checked={!isElectric}  onClick={() => setIsElectric(!isElectric)}/>}
                      <Item
                        label="Electricity Consumption (kwh)"
                        name="elec_consumption"
                        rules={!(isElectric || isDisabled) &&[{ required: true, message: 'Please enter your Electricity Consumption!' }]}
                      >
                        <Input style={{width:'20vw'}} disabled={isElectric || isDisabled}/>
                      </Item>
                    </Space>
                  </Col>
                </Row>
                <Row className='m-2'>
                  <Col>
                    <Space>
                      {!isDisabled &&<Checkbox value="water_meter" checked={!isWater}  onClick={() => setIsWater(!isWater)}/>}
                      <Item
                        label="Water Consumption (cubic meter)"
                        name="water_consumption"
                        rules={!(isWater || isDisabled) &&[{ required: true, message: 'Please enter your Water Consumption!' }]}
                      >
                        <Input style={{width:'20vw'}} disabled={isWater || isDisabled}/>
                      </Item>
                    </Space>
                  </Col>
                </Row>
                <Row className='m-2'>
                  <Col>
                    <Space>
                      {!isDisabled && <Checkbox value="gas_meter"  checked={!isGas}   onClick={() => setIsGas(!isGas)}/>}
                      <Item
                        label="Gas Consumption (cubic meter) "
                        name="gas_consumption"
                        rules={!(isGas || isDisabled) &&[{ required: true, message: 'Please enter your confirm Gas Consumption!' }]}
                      >
                        <Input style={{width:'20vw'}} disabled={isGas || isDisabled}/>
                      </Item>
                    </Space>
                  </Col>
                </Row>
              </Col>
              <Col span={5}>
                {options.map((option) => (
                  <Row>
                    <Col className='mt-5 mb-4'>
                      <Checkbox
                        key={option.value}
                        value={option.value}
                        checked={checkedValues?.includes(option.value)}
                        onChange={() => onCheckedValues(option.value)}
                      >
                        {option.label}
                      </Checkbox>                
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          </Form>  
          <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
            <Col span={24} className='p-2'>
              <Table
                dataSource={parkingDataTable}
                columns={columns}
                pagination={false}
                bordered
              />
              {/* <Button 
                type="primary" 
                className='mt-4' 
                onClick={handleAddRow}
              >
                Add Row
              </Button> */}
            </Col>
          </Row>
          <Row className='btn-footer'>
            <Space className='p-2'>
              <Button
                onClick={() => navigate('/tenant')}
                className='cancel-color btn-header'
              >
                Cancel
              </Button>
              {
                !isDisabled && (
                  <Button 
                    type="primary" 
                    onClick={() => handleAddRates()}
                    loading={loading}
                    disabled={handleSaveValidation()}
                    className='button-color btn-header'
                  >
                    Save
                  </Button>
                )
              }
            </Space>
          </Row>
        </Layout>
    </Layout>
    
  )
}

export default EditTenantRate
